import { render, staticRenderFns } from "./dashboard-shared-detail.vue?vue&type=template&id=e81edc70"
import script from "./dashboard-shared-detail.vue?vue&type=script&lang=js"
export * from "./dashboard-shared-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports